import React from 'react';
import './SalesPopup.css';
import useTranslation from '../hooks/useTranslation';

export default function SalesPopup({ show = true, onClose }) {
  const { t } = useTranslation();
  if (!show) return null;

  return (
    <div className="sales-popup-bg" onClick={onClose}>
      <div className="sales-popup" onClick={(e) => e.stopPropagation()} style={{background: 'var(--color-modal-bg)', color: 'var(--color-modal-text)'}}>
        <button
          type="button"
          className="sales-popup-close"
          onClick={onClose}
          aria-label={t('Close popup')}
        >
          ×
        </button>
        
        <div className="sales-popup-content">
                      {/* Insert monster toy image here */}
            <div className="monster-image">
              <img src="/spop.gif" alt="Monster toy" />
            </div>
          
          <div className="sales-message">
            <h3>{t('Contact Sales Team')}</h3>
            <p>{t('Contact the Neurolonic sales team at')}</p>
            <a
  href="mailto:Oracle@Neurolonic.com"
  className="sales-email"
  onClick={e => e.stopPropagation()}
  rel="noopener noreferrer"
>
  Oracle@Neurolonic.com
</a>
          </div>
        </div>
      </div>
    </div>
  );
} 